<template>
  <div class="sponsorship-level-info">
    <p v-if="isCurrentLevel">
      {{$t('subscriptions.this_is_your_current_level')}}
      {{ isCanceled ? ' ' + $t('subscriptions.you_have_canceled_this_subscription') + ' ' + $t('subscriptions.you_can_subscribe_again', { 'date':nextLevelDateFormatted }) : '' }}
      {{ downgradePlanned ? ' ' + $t('subscriptions.you_have_planned_the_transition_to_the_level', { 'name':currentSubscription.nextLevel.name }) : '' }}
    </p>
    <p v-else-if="isHigherLevel">{{$t('subscriptions.this_level_is_higher_than_your_current_one', { 'name':currentLevelName })}}</p>
    <p v-else-if="isNextLevel">{{$t('subscriptions.this_level_is_next', { 'date':nextLevelDateFormatted })}}</p>
    <p v-else-if="isLowerLevel">{{$t('subscriptions.this_level_is_lower_than_your_current_one', { 'date':nextLevelDateFormatted })}}</p>
    {{$t('subscriptions.available_at_this_level')}}<span v-for="(grant, index) in freeEffectGrants" :key="grant.class_id"> {{ grant.class_name }}: {{ grant.limit }} {{ $t(`sponsor.per_${grant.period}`) }}<span v-if="index < freeEffectGrants.length - 1">,</span><span v-else>.</span></span>
    <div class="subscribe-row">
      <button class="btn-orange" @click="subscribe" v-if="isHigherLevel || isCanceled || !haveActiveSubscription" :disabled="$store.getters.subscriptionRequestInProgress">{{ $t('subscriptions.subscribe') }}</button>
      <button class="btn-orange" @click="subscribe" v-if="isLowerLevel && !isNextLevel" :disabled="$store.getters.subscriptionRequestInProgress">{{ $t('subscriptions.schedule_transition') }}</button>
      <button class="btn-orange" @click="subscribe" v-if="isCurrentLevel && downgradePlanned" :disabled="$store.getters.subscriptionRequestInProgress">{{ $t('subscriptions.cancel_transition') }}</button>
    </div>
  </div>
</template>
<script>

import moment from "moment/moment";
import { SponsorshipLevel } from "../store/models/SponsorshipLevel";
import SubscriptionStatus from "../store/models/SubscriptionStatus";

export default {
  name: 'SponsorshipLevelInfo',
  props: {
    level: {
      type: SponsorshipLevel,
      default: null,
    },
  },
  computed: {
    freeEffectGrants() {
      return this.level.grants;
    },
    haveActiveSubscription() {
      return this.$store.getters.currentSubscription?.status === SubscriptionStatus.Paid;
    },
    isHigherLevel() {
        return this.haveActiveSubscription? this.$store.getters.currentSubscription.level.pricePerYearInUSD < this.level.pricePerYearInUSD : false;
    },
    isLowerLevel() {
        return this.haveActiveSubscription? this.$store.getters.currentSubscription.level.pricePerYearInUSD > this.level.pricePerYearInUSD : false;
    },
    nextLevelDateFormatted() {
      return this.currentSubscription?.paidTill ? moment(this.currentSubscription.paidTill).format(this.$t('date_time_format')) : null;
    },
    currentLevelName() {
      return this.haveActiveSubscription? this.$store.getters.currentLevel?.name : null;
    },
    currentSubscription() {
      return this.$store.getters.currentSubscription;
    },
    isCurrentLevel() {
      return this.haveActiveSubscription? this.$store.getters.currentLevel?.externalID === this.level.externalID : false;
    },
    isCanceled() {
      return this.haveActiveSubscription? this.isCurrentLevel && !this.$store.getters.currentSubscription.recurrent && this.$store.getters.currentSubscription.nextRecurrentPayment == null && this.$store.getters.currentSubscription.nextLevel == null : false;
    },
    isNextLevel() {
      return this.haveActiveSubscription? this.$store.getters.currentSubscription.nextLevel != null && this.$store.getters.currentSubscription.nextLevel.externalID === this.level.externalID : false;
    },
    downgradePlanned() {
      return this.$store.getters.downgradePlanned;
    },
  },
  methods: {
    subscribe() {
      this.$store.dispatch('subscribe', this.level.ID);
    },
  },
};
</script>
<style lang="scss">
.sponsorship-level-info {
    .subscribe-row {
        margin-top: 16px;
    }
    .btn-orange {
        margin-left: 0;
        cursor: pointer;
        align-self: flex-end;
    }
}
</style>
